export function parsePhoneInput(value) {
  if (!value || typeof value !== "string") {
    return { internationalCode: "", localCode: "", phoneNumber: "" };
  }
  const digits = value.replace(/\D/g, "");
  if (digits.length === 0) {
    return { internationalCode: "", localCode: "", phoneNumber: "" };
  }
  if (value.trim().startsWith("+")) {
    const oneDigitCountry = digits[0] === "1" || digits[0] === "7";
    const internationalCode = oneDigitCountry ? digits.slice(0, 1) : digits.slice(0, 2);
    const phoneNumber = digits.slice(internationalCode.length);
    return {
      internationalCode: internationalCode || "",
      localCode: "",
      phoneNumber: phoneNumber || "",
    };
  }
  return {
    internationalCode: "",
    localCode: "",
    phoneNumber: digits,
  };
}

export function formatPhoneForDisplay(internationalCode, localCode, phoneNumber) {
  const parts = [];
  if (internationalCode) parts.push("+" + internationalCode);
  if (localCode) parts.push(localCode);
  if (phoneNumber) parts.push(phoneNumber);
  return parts.join(" ").trim() || "";
}
